import React from "react";
import "./App.css";
import Home from "./Home";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import SearchPage from "./SearchPage";
import Footer from "./Footer";

function App() {
  return (
    // BEM
    <div className="app">
       <Router>
        <Switch>
          <Route path="/search">
            <SearchPage/>
          </Route>
          <Route path="/">
            <Home />
           <Footer />

          </Route>
        </Switch> 
       </Router> 
    </div>
  );
}

export default App;